// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const x: number = "Hello"; // No TypeScript error, even though this is invalid.

import { LeaderboardService } from "../services/LeaderboardService";
import { GameEventService } from "../services/GameEventService";
import { Page } from "../enums/Page";
import { css, htmlArray } from "../helpers/webComponents";

const styles: string = css`
:host {
    display: block;
    font-family: Arial, sans-serif;
    text-align: center;
    padding: 20px;
    background-color: rgba(0, 0, 0, 0.75);
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.score-container {
    padding: 15px;
    background: #e6e6e6;  /* Lichtere achtergrondkleur voor de score container */
    border-radius: 8px;
    margin: 10px 0;
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
    color: #333; /* Donkerder kleur voor tekst binnen de score container */
}

.total-score {
    color: #D8BFD8; /* Lichte paarse kleur voor de totale score */
    padding: 10px;
    border-radius: 8px;
    font-weight: bold;
}

button {
    background: #52478b;
    color: white;
    border: none;
    padding: 10px 20px;
    cursor: pointer;
    font-size: 16px;
    border-radius: 5px;
    transition: 0.3s ease;
}

button:hover {
    background: #332c57;
}

#canvasButton {
    font-size: 18px;
    padding: 12px 24px;
    border-radius: 10px;
    margin-right: 20px;
    display: inline-block;
}

#leaderboardButton {
    font-size: 16px;
    padding: 12px 24px;
    border-radius: 10px;
    display: inline-block;
}

.new-high-score {
    color: gold;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
    animation: pulse 1.5s infinite;
}

@keyframes pulse {
    0% { transform: scale(1); }
    50% { transform: scale(1.1); }
    100% { transform: scale(1); }
}

`;

export class ResultComponent extends HTMLElement {
    private readonly _leaderboardService: LeaderboardService = new LeaderboardService();
    private readonly _gameEventService: GameEventService = new GameEventService();
    private _isNewTopScore: boolean = false;

    private _scoreData: {
        itemsCollected: number;
        itemsScore: number;
        goodEnd: boolean;
        endPoints: number;
        totalScore: number;
        pointsPerItem: number;
        _scoreData: number;
    } | null = null;

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        console.log("ResultComponent connectedCallback: attaching shadow DOM.");
        void this.fetchFinalScore();
    }

    private async fetchFinalScore(): Promise<void> {
        console.log("Fetching final score from leaderboard service...");
        try {
            this._scoreData = await this._leaderboardService.fetchFinalScore();
            console.log("Final score data fetched successfully:", this._scoreData);
            this.render();
            await this.saveGameData();
        }
        catch (error) {
            console.error("Error fetching final score:", error);
        }
    }

    private async saveGameData(): Promise<void> {
        if (!this._scoreData) {
            console.warn("No score data available to save.");
            return;
        }

        const { itemsCollected, totalScore, goodEnd } = this._scoreData;
        const userId: number = parseInt(localStorage.getItem("userId") || "0", 10);
        const ending: "good" | "bad" = goodEnd ? "good" : "bad";

        console.log("Saving game data...");
        const result: {
            success: boolean;
            isNewTopScore: boolean;
        } = await this._leaderboardService.fetchGameData(userId, ending, itemsCollected, totalScore);

        if (result.success) {
            console.log("Game data successfully saved.");
            this._isNewTopScore = result.isNewTopScore;
        }
        else {
            console.error("Failed to save game data.");
        }
        console.log("Render wordt opnieuw uitgevoerd.");
        this.render(); // Render opnieuw na het opslaan van de score
    }

    private render(): void {
        if (!this.shadowRoot || !this._scoreData) {
            console.warn("No shadowRoot or scoreData available for rendering.");
            return;
        }

        const { itemsCollected, itemsScore, totalScore, goodEnd, pointsPerItem } = this._scoreData;

        console.log("Rendering result with score data:", this._scoreData);
        console.log("Rendering new high score message:", this._isNewTopScore);

        const newHighScoreMessage: HTMLElement[] = this._isNewTopScore
            ? htmlArray`<p class="new-high-score">🎉 Nieuwe topscore behaald! 🎉</p>`
            : htmlArray``;

        const elements: HTMLElement[] = htmlArray`
            <style>${styles}</style>
            <h2>Spelresultaat</h2>
            ${newHighScoreMessage}
            <div class="score-container">
                <p>Items verzameld: ${itemsCollected} x ${pointsPerItem} = ${itemsScore} punten</p>
                <p>Einde: ${goodEnd ? "Goed einde" : "Slecht einde"} = ${this._scoreData.endPoints} punten</p>
                <p><strong class="total-score">Totale score: ${totalScore} punten</strong></p>
            </div>
            <div>
                <button id="canvasButton">🔄 Opnieuw spelen</button>
                <button id="leaderboardButton">🏆 Bekijk Leaderboard</button>
            </div>
        `;

        this.shadowRoot.innerHTML = "";
        this.shadowRoot.append(...elements);

        this.shadowRoot.querySelector("#leaderboardButton")?.addEventListener("click", () => {
            console.log("Leaderboard button clicked. Navigating to Leaderboard page...");
            this._gameEventService.switchPage(Page.Leaderboard);
            localStorage.setItem("leaderboardSource", "resultComponent");
        });

        this.shadowRoot.querySelector("#canvasButton")?.addEventListener("click", () => {
            console.log("Terug naar Canvas button clicked. Navigating to Canvas...");
            this._gameEventService.switchPage(Page.Canvas);
        });
    }
}
